export default {
  partnerBookingSolution: {
    header: {
      title: 'Booking solution',
      description:
        'For your website, Instagram, and more. Sell tickets, team events, and vouchers directly on your page.',
      titleTextColor: 'white',
      descriptionTextColor: 'white',
      buttonLabel: 'Schedule a demo',
      buttonColor: 'var(--kft-primary)',
      buttonHoverColor: 'var(--kft-primary)',
      buttonBgColor: 'white',
      buttonHoverBgColor: '#dde7e8',
      bgColor: 'var(--kft-primary)',
    },

    softwareInfo: {
      sectionTitle: 'konfetti booking solution',
      actionText: 'Schedule a demo',
      cards: [
        {
          title: 'Payment options',
          subtitle:
            'Your customers benefit from a variety of digital payment options.\n',
          imageUrl:
            '/_nuxt3-static/partner/booking-solution/payment-options.png',
          imageAlt: 'Img description',
        },
        {
          title: 'Centrallized administration',
          subtitle:
            'Manage all your courses and bookings centrally in one system and reduce your manual effort.\n',
          imageUrl:
            '/_nuxt3-static/partner/booking-solution/central-administration.png',
          imageAlt: 'Img description',
        },
        {
          title: 'No contract duration',
          subtitle:
            'Test the booking solution completely without obligation, without being tied to minimum contract terms.\n',
          imageUrl:
            '/_nuxt3-static/partner/booking-solution/contract-period.png',
          imageAlt: 'Img description',
        },
      ],
    },

    processSteps: {
      title: 'Make selling your tickets even easier for your customers',
      items: {
        1: {
          image: '/team-events/michael-l-geschaftsfuhrer-hyrise-academy.webp',
          title: 'Direct sale of tickets, vouchers, and team events',
          description:
            'Use our conversion-optimized ticket shop for your website, Instagram, and more. Reach more customers and effortlessly sell tickets, vouchers, and team events around the clock.',
          link: '#',
          linkText: '',
          circleContent: '<i class="bi bi-currency-exchange"></i>',
        },
        2: {
          image: '/team-events/ceo-pospulse.webp',
          title: 'Automatic billing & payout',
          description:
            'The confetti booking solution takes care of the administrative tasks behind every sale. Billing and payouts of your sales happen automatically. You can fully focus on your creative work.',
          link: '#',
          linkText: '',
          circleContent: '<i class="bi bi-credit-card-fill"></i>',
        },
        3: {
          image: '/team-events/Ostrom_Founders_2-800x533.webp',
          title: 'Straightforward & fast implementation',
          description:
            'We support you in integrating and optimizing the booking solution on your website and share our experience with you - for your success.',
          link: '#',
          linkText: '',
          circleContent: '<i class="bi bi-check-circle-fill"></i>',
        },
      },
    },

    stepsToJoin: {
      title: "It's that easy:",
      items: {
        1: {
          image: '/_nuxt3-static/partner/booking-solution/join-bs-1.webp',
          title: 'Book a free demo',
          description:
            'Choose a suitable date directly and get answers to all your questions. We are happy to advise you on which version of the booking solution best suits you and your offering.',
        },
        2: {
          image: '/_nuxt3-static/partner/booking-solution/join-bs-2.webp',
          title: 'Integration on your website',
          description:
            "Right after the demo, you'll receive your personal booking solution from us. Integration takes just a few minutes and is very straightforward. We're more than happy to walk you through it in a video call.",
        },
        3: {
          image: '/_nuxt3-static/partner/booking-solution/join-bs-3.webp',
          title: 'Delight your customers',
          description:
            "And you're ready to go. Our optimized booking solution makes it even easier for your customers to purchase tickets and vouchers for your events with just a few clicks.",
        },
      },
    },

    heroes: {
      first: {
        title: 'konfetti Success Case',
        subtitle:
          "\"Thanks to Konfetti, we now conduct fully booked cocktail classes several times a week. In the past few months, we've hired two new team members to accommodate the demand.\" - CEO & Partner of 'die Krake'. Do you want to know how they accomplished it?",
        image: '/_nuxt3-static/partner/booking-solution/hero-first-bs.webp',
        mobileImage:
          '/_nuxt3-static/partner/booking-solution/hero-first-bs-mobile.webp',
        buttonText: 'Request informational material',
      },
    },

    faq: [
      {
        title: 'Frequently Asked Questions',
        questions: [
          {
            question:
              'What options are available for implementing the booking solution on my website?',
            answer:
              'If you want to showcase only one course per page, you can integrate a widget. This booking window is seamlessly incorporated into your existing page. For multiple courses or integration on Instagram, there is a booking link that bundles all your courses and the option to purchase a voucher. You can also use this link as your own online shop.',
          },
          {
            question:
              'Do I receive support for the integration of the booking solution?',
            answer:
              'We are more than happy to assist you in placing the booking solution perfectly on your website. We can arrange a brief video call for this purpose. Even after implementation, we will continue to provide guidance to help you get the most out of the booking solution..',
          },
          {
            question: 'Is Konfetti the right booking solution for my business?',
            answer:
              'Do you offer courses, workshops, or team-building events? Then Konfetti is the perfect software solution for you. We have developed Konfetti in close collaboration with our partners. The goal of our all-in-one solution is to make your everyday work easier by automating routine processes and selling tickets online for you. ',
          },
          {
            question: 'Can I try out the booking solution?',
            answer:
              'You can test the booking solution at any time, free of charge and without any obligation. It can be easily integrated and removed from your site if, for any reason, you are not satisfied. :)',
          },
          {
            question:
              'Can I speak with someone from Konfetti about the booking solution?',
            answer:
              "Feel free to send an email to partner{'@'}gokonfetti.com or book your first non-binding consultation.",
          },
        ],
      },
    ],
  },
}
